import "Styles/templates/page.fit-guide.scss";
import TableResponsive from '../vue/table-responsive';

TableResponsive();
